import React from 'react';
export function ClosingStatement() {
  return <section className="px-5 py-10" data-id="element-34" data-mp="1dxiqsb3kb3an">
      <div className="rounded-3xl border border-teal-400/25 bg-teal-500/10 p-6 text-center" data-id="element-35" data-mp="2t8sxtstc6x93">
        <p className="text-xl font-black leading-snug text-white" data-id="element-36" data-mp="2o97uz7b1q4r3">
          Cada semana que pasa sin ordenar tu consultorio te cuesta horas,
          materiales y pacientes que se van.
        </p>
        <p className="mt-3 text-sm leading-relaxed text-teal-50/85" data-id="element-37" data-mp="3gxvn9mu7pue5">
          Hoy podés seguir improvisando con cuadernos y precios calculados a
          ojo… o tener todo el sistema andando esta misma tarde. La decisión
          toma un minuto; el orden te queda para siempre.
        </p>
      </div>
    </section>;
}